export const eventBus = new Vue();
